import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { origemLancamentoCadastroDesconhecida, origemLancamentoCadastroSogivendas, origemLancamentoCadastroErp, origemLancamentoCadastroEcommerce } from '../../../../models/origem-lancamento-cadastro';

@Component({
    selector: 'sgt-origem-lancamento-cadastro-multiselect',
    templateUrl: './origem-lancamento-cadastro-multiselect.component.html',
    styleUrls: ['./origem-lancamento-cadastro-multiselect.component.less']
})
export class OrigemLancamentoCadastroMultiselectComponent implements OnInit {
    /** Origens selecionadas */
    @Input() origens: number[];
    /** Ao alterar a seleção das origens */
    @Output() origensChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Origem';
    @Input() checked = 'Origem'
    @Input() checkedPlural = 'Origens';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma origem encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowDesconhecida = false;
    @Input() isShowSogivendas = true;
    @Input() isShowErp = true;
    @Input() isShowEcommerce = true;

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-origem-lancamento-cadastro ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as origens de lançamentos para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowDesconhecida) {
            selects.push({
                id: origemLancamentoCadastroDesconhecida.id,
                name: origemLancamentoCadastroDesconhecida.nome,
                classes: 'multiselect-item-origem-lancamento-cadastro multiselect-item-origem-lancamento-cadastro-desconhecida'
            });
        }
        if (this.isShowSogivendas) {
            selects.push({
                id: origemLancamentoCadastroSogivendas.id,
                name: origemLancamentoCadastroSogivendas.nome,
                classes: 'multiselect-item-origem-lancamento-cadastro multiselect-item-origem-lancamento-cadastro-sogivendas'
            });
        }
        if (this.isShowErp) {
            selects.push({
                id: origemLancamentoCadastroErp.id,
                name: origemLancamentoCadastroErp.nome,
                classes: 'multiselect-item-origem-lancamento-cadastro multiselect-item-origem-lancamento-cadastro-erp'
            });
        }
        if (this.isShowEcommerce) {
            selects.push({
                id: origemLancamentoCadastroEcommerce.id,
                name: origemLancamentoCadastroEcommerce.nome,
                classes: 'multiselect-item-origem-lancamento-cadastro multiselect-item-origem-lancamento-cadastro-ecommerce'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das origens */
    onChange() {
        this.origensChange.emit(this.origens);
    }
}
